import React, { useState, useEffect, useRef } from "react";
import { collection, query, where, orderBy, limit, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

export default function DataStream() {
  const [messages, setMessages] = useState([]);
  const bottomRef = useRef(null);

  useEffect(() => {
    const q = query(
      collection(db, "Chat"),
      where("chatToChannel", "==", "DataStream"),
      orderBy("chatTimestamp", "desc"),
      limit(100)
    );

    const unsub = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setMessages(data.reverse());
    });

    return () => unsub();
  }, []);

  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  return (
<div
  className="datastream-container terminal-border custom-scrollbar"
  style={{ 
    overflowY: "auto", 
    height: "90%", 
    background: "rgba(0, 0, 0, 0.4)",
    padding: "8px",
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: "0.8rem",
    lineHeight: "1.2",
    backdropFilter: "blur(2px)"
  }}
>
      {messages.map((msg) => (
        <div 
          key={msg.id} 
          className="datastream-message" 
          style={{ 
            marginBottom: "2px", 
            borderBottom: "1px solid rgba(80, 227, 194, 0.05)",
            paddingBottom: "1px",
            display: "flex",
            gap: "8px"
          }}
        >
          <span 
            className="datastream-time" 
            style={{ color: "#555", whiteSpace: "nowrap" }}
          >
            {msg.chatCurrentTime || "--:--"}
          </span>
          
          <span 
            className="datastream-text" 
            style={{ 
              color: "#50e3c2",
              textShadow: "0 0 5px rgba(80, 227, 194, 0.2)",
              wordBreak: "break-all"
            }}
          >
            <span style={{ color: "rgba(80, 227, 194, 0.5)", marginRight: "4px" }}></span>
            {msg.chatMessage}
          </span>
        </div>
      ))}
      <div ref={bottomRef} />
    </div>
  );
}